/**
 * CardDrawnToast.tsx — WEB.4.R2.CF
 *
 * Transient toast shown when a free card is auto-added to hand (Case C).
 * Auto-dismisses after 2s. Click to dismiss early.
 *
 * VISIBLE WHEN: cardDrawnToast !== null
 * TEST PATH: free card draw from bureaucrat with empty hand → toast appears → auto-hides ~2s
 */

import type React from "react";
import { useEffect } from "react";
import { useGameStore } from "../../store/game-store.js";
import styles from "./CardDrawnToast.module.css";

const TOAST_DURATION_MS = 2000;

export function CardDrawnToast(): React.ReactElement | null {
  const cardDrawnToast = useGameStore((s) => s.cardDrawnToast);
  const dismissCardDrawnToast = useGameStore((s) => s.dismissCardDrawnToast);

  useEffect(() => {
    if (cardDrawnToast === null) return;
    const timer = window.setTimeout(() => {
      dismissCardDrawnToast();
    }, TOAST_DURATION_MS);
    return () => window.clearTimeout(timer);
  }, [cardDrawnToast, dismissCardDrawnToast]);

  if (cardDrawnToast === null) return null;

  return (
    <button
      type="button"
      className={styles.toast}
      onClick={dismissCardDrawnToast}
      aria-label="Dismiss card drawn notification"
      data-testid="card-drawn-toast"
    >
      <div className={styles.title}>📋 CARD DRAWN</div>
      <div className={styles.cardName}>{cardDrawnToast.cardName}</div>
      <div className={styles.hint}>Added to hand</div>
    </button>
  );
}
